import React from 'react'
import { Link } from 'react-router-dom';
import bussinessGrowOneLeft1 from "../../assets/images/resources/business-grow-one-left-img-one.jpg";
import bussinessGrowOneLeft2 from "../../assets/images/resources/business-grow-one-left-img-two.jpg";
import bussinessGrowOneLeft3 from "../../assets/images/resources/business-grow-one-left-img-three.jpg";
import bussinessGrowOneLeft4 from "../../assets/images/shapes/business-grow-one-left-img-four.png";
import bussinessGrowOneLeft5 from "../../assets/images/shapes/business-grow-one-left-img-five-shape.png";

function BussinessGrow() {
  return (
    <div>
      <section className="business-grow-and-process">
        <div className="business-grow-one">
          <div className="business-grow-one-shape" />
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="business-grow-one-left-box">
                  <div
                    className="business-grow-one-left-img-top wow fadeInLeft animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="100ms"
                  >
                    <div className="business-grow-one-left-img-one">
                      <img
                        src={bussinessGrowOneLeft1}
                        alt="business-grow-one-left-img-one"
                      />
                    </div>
                    <div className="business-grow-one-left-img-two">
                      <img
                        src={bussinessGrowOneLeft2}
                        alt="business-grow-one-left-img-two"
                      />
                    </div>
                  </div>
                  <div
                    className="business-grow-one-left-img-bottom wow fadeInLeft animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="300ms"
                  >
                    <div className="business-grow-one-left-img-three">
                      <img
                        src={bussinessGrowOneLeft3}
                        alt="business-grow-one-left-img-three"
                      />
                    </div>
                    <div className="business-grow-one-left-img-four">
                      <img
                        src={bussinessGrowOneLeft4}
                        alt="business-grow-one-left-img-four"
                      />
                      <img
                        src={bussinessGrowOneLeft5}
                        alt="business-grow-one-left-img-five-shape"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="business-grow-one-right-box">
                  <div
                    className="section-four-title wow fadeInRight animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="100ms"
                  >
                    <div className="section-four-title-title">
                      <h2>
                        Best Solutions to Grow your{" "}
                        <span className="section-four-title-title-inner">
                          Business
                        </span>
                        Solutions
                      </h2>
                    </div>
                  </div>
                  <div
                    className="section-four-details wow fadeInRight animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="300ms"
                  >
                    <p>
                      Sed perspiciatis unde omnis natus voluptatem
                      accusantiuc doloremue laudantium totamem aperiam eaque
                      quinventore veritatis quasi architecto beatae vitae
                      dicta ways.
                    </p>
                  </div>
                  <div
                    className="business-grow-one-right-btn wow fadeInRight animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="500ms"
                  >
                    <Link
                      to="/projects"
                      className="main-btn-four thm-btn"
                    >
                      Get Started
                      <i className="icon-right-arrow" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="process-two">
          <div className="process-two-shape" />
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-two-left-box">
                  <div
                    className="section-four-title wow fadeInLeft animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="100ms"
                  >
                    <div className="section-four-title-title">
                      <h2>
                        Optimize your website to{" "}
                        <span className="section-four-title-title-inner">
                          Achieve
                        </span>
                        maximum results
                      </h2>
                    </div>
                  </div>
                  <div
                    className="process-two-left-inner-box wow fadeInLeft animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="300ms"
                  >
                    <div className="process-two-left-inner-number">
                      <h4>
                        <span>01</span>
                      </h4>
                    </div>
                    <div className="process-two-left-inner-title-box">
                      <h4>Endless Possibilities</h4>
                      <p>
                        At vero eos et accusamus etiusto dignissimos ducimus
                        qui blanditiis praesentium
                      </p>
                    </div>
                  </div>
                  <div
                    className="process-two-left-inner-box wow fadeInLeft animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="500ms"
                  >
                    <div className="process-two-left-inner-number">
                      <h4>
                        <span>02</span>
                      </h4>
                    </div>
                    <div className="process-two-left-inner-title-box">
                      <h4>Process Optimization</h4>
                      <p>
                        To take trivial example which of us physical
                        exercise, except to advantage
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="process-two-right-box">
                  <div className="process-two-right-inner">
                    <div
                      className="process-two-right-detail process-two-right-detail-one wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="100ms"
                    >
                      <i className="icon-check-mark1" />
                      <h4>Keyword Ranking Services</h4>
                    </div>
                    <div
                      className="process-two-right-detail process-two-right-detail-two wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="300ms"
                    >
                      <i className="icon-check-mark1" />
                      <h4>Site Health Optimization</h4>
                    </div>
                    <div
                      className="process-two-right-detail process-two-right-detail-three wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="500ms"
                    >
                      <i className="icon-check-mark1" />
                      <h4>Performance Maintained</h4>
                    </div>
                    <div
                      className="process-two-right-detail process-two-right-detail-four wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="700ms"
                    >
                      <i className="icon-check-mark1" />
                      <h4>Marketing Automation</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default BussinessGrow
